var map = {
	"./af.js": "./src/date-picker/locale/af.js",
	"./ar-dz.js": "./src/date-picker/locale/ar-dz.js",
	"./ar-kw.js": "./src/date-picker/locale/ar-kw.js",
	"./ar-ly.js": "./src/date-picker/locale/ar-ly.js",
	"./ar-ma.js": "./src/date-picker/locale/ar-ma.js",
	"./ar-sa.js": "./src/date-picker/locale/ar-sa.js",
	"./ar-tn.js": "./src/date-picker/locale/ar-tn.js",
	"./ar.js": "./src/date-picker/locale/ar.js",
	"./az.js": "./src/date-picker/locale/az.js",
	"./be.js": "./src/date-picker/locale/be.js",
	"./bg.js": "./src/date-picker/locale/bg.js",
	"./bm.js": "./src/date-picker/locale/bm.js",
	"./bn.js": "./src/date-picker/locale/bn.js",
	"./bo.js": "./src/date-picker/locale/bo.js",
	"./br.js": "./src/date-picker/locale/br.js",
	"./bs.js": "./src/date-picker/locale/bs.js",
	"./ca.js": "./src/date-picker/locale/ca.js",
	"./cs.js": "./src/date-picker/locale/cs.js",
	"./cv.js": "./src/date-picker/locale/cv.js",
	"./cy.js": "./src/date-picker/locale/cy.js",
	"./da.js": "./src/date-picker/locale/da.js",
	"./de-at.js": "./src/date-picker/locale/de-at.js",
	"./de-ch.js": "./src/date-picker/locale/de-ch.js",
	"./de.js": "./src/date-picker/locale/de.js",
	"./dv.js": "./src/date-picker/locale/dv.js",
	"./el.js": "./src/date-picker/locale/el.js",
	"./en-au.js": "./src/date-picker/locale/en-au.js",
	"./en-ca.js": "./src/date-picker/locale/en-ca.js",
	"./en-gb.js": "./src/date-picker/locale/en-gb.js",
	"./en-ie.js": "./src/date-picker/locale/en-ie.js",
	"./en-il.js": "./src/date-picker/locale/en-il.js",
	"./en-nz.js": "./src/date-picker/locale/en-nz.js",
	"./en-sg.js": "./src/date-picker/locale/en-sg.js",
	"./en.js": "./src/date-picker/locale/en.js",
	"./eo.js": "./src/date-picker/locale/eo.js",
	"./es-do.js": "./src/date-picker/locale/es-do.js",
	"./es-us.js": "./src/date-picker/locale/es-us.js",
	"./es.js": "./src/date-picker/locale/es.js",
	"./et.js": "./src/date-picker/locale/et.js",
	"./eu.js": "./src/date-picker/locale/eu.js",
	"./fa.js": "./src/date-picker/locale/fa.js",
	"./fi.js": "./src/date-picker/locale/fi.js",
	"./fo.js": "./src/date-picker/locale/fo.js",
	"./fr-ca.js": "./src/date-picker/locale/fr-ca.js",
	"./fr-ch.js": "./src/date-picker/locale/fr-ch.js",
	"./fr.js": "./src/date-picker/locale/fr.js",
	"./fy.js": "./src/date-picker/locale/fy.js",
	"./ga.js": "./src/date-picker/locale/ga.js",
	"./gd.js": "./src/date-picker/locale/gd.js",
	"./gl.js": "./src/date-picker/locale/gl.js",
	"./gom-latn.js": "./src/date-picker/locale/gom-latn.js",
	"./gu.js": "./src/date-picker/locale/gu.js",
	"./he.js": "./src/date-picker/locale/he.js",
	"./hi.js": "./src/date-picker/locale/hi.js",
	"./hr.js": "./src/date-picker/locale/hr.js",
	"./hu.js": "./src/date-picker/locale/hu.js",
	"./hy-am.js": "./src/date-picker/locale/hy-am.js",
	"./id.js": "./src/date-picker/locale/id.js",
	"./is.js": "./src/date-picker/locale/is.js",
	"./it-ch.js": "./src/date-picker/locale/it-ch.js",
	"./it.js": "./src/date-picker/locale/it.js",
	"./ja.js": "./src/date-picker/locale/ja.js",
	"./jv.js": "./src/date-picker/locale/jv.js",
	"./ka.js": "./src/date-picker/locale/ka.js",
	"./kk.js": "./src/date-picker/locale/kk.js",
	"./km.js": "./src/date-picker/locale/km.js",
	"./kn.js": "./src/date-picker/locale/kn.js",
	"./ko.js": "./src/date-picker/locale/ko.js",
	"./ku.js": "./src/date-picker/locale/ku.js",
	"./ky.js": "./src/date-picker/locale/ky.js",
	"./lb.js": "./src/date-picker/locale/lb.js",
	"./lo.js": "./src/date-picker/locale/lo.js",
	"./lt.js": "./src/date-picker/locale/lt.js",
	"./lv.js": "./src/date-picker/locale/lv.js",
	"./me.js": "./src/date-picker/locale/me.js",
	"./mi.js": "./src/date-picker/locale/mi.js",
	"./mk.js": "./src/date-picker/locale/mk.js",
	"./ml.js": "./src/date-picker/locale/ml.js",
	"./mn.js": "./src/date-picker/locale/mn.js",
	"./mr.js": "./src/date-picker/locale/mr.js",
	"./ms-my.js": "./src/date-picker/locale/ms-my.js",
	"./ms.js": "./src/date-picker/locale/ms.js",
	"./mt.js": "./src/date-picker/locale/mt.js",
	"./my.js": "./src/date-picker/locale/my.js",
	"./nb.js": "./src/date-picker/locale/nb.js",
	"./ne.js": "./src/date-picker/locale/ne.js",
	"./nl-be.js": "./src/date-picker/locale/nl-be.js",
	"./nl.js": "./src/date-picker/locale/nl.js",
	"./nn.js": "./src/date-picker/locale/nn.js",
	"./oc-lnc.js": "./src/date-picker/locale/oc-lnc.js",
	"./pa-in.js": "./src/date-picker/locale/pa-in.js",
	"./pl.js": "./src/date-picker/locale/pl.js",
	"./pt-br.js": "./src/date-picker/locale/pt-br.js",
	"./pt.js": "./src/date-picker/locale/pt.js",
	"./ro.js": "./src/date-picker/locale/ro.js",
	"./ru.js": "./src/date-picker/locale/ru.js",
	"./sd.js": "./src/date-picker/locale/sd.js",
	"./se.js": "./src/date-picker/locale/se.js",
	"./si.js": "./src/date-picker/locale/si.js",
	"./sk.js": "./src/date-picker/locale/sk.js",
	"./sl.js": "./src/date-picker/locale/sl.js",
	"./sq.js": "./src/date-picker/locale/sq.js",
	"./sr-cyrl.js": "./src/date-picker/locale/sr-cyrl.js",
	"./sr.js": "./src/date-picker/locale/sr.js",
	"./ss.js": "./src/date-picker/locale/ss.js",
	"./sv.js": "./src/date-picker/locale/sv.js",
	"./sw.js": "./src/date-picker/locale/sw.js",
	"./ta.js": "./src/date-picker/locale/ta.js",
	"./te.js": "./src/date-picker/locale/te.js",
	"./tet.js": "./src/date-picker/locale/tet.js",
	"./tg.js": "./src/date-picker/locale/tg.js",
	"./th.js": "./src/date-picker/locale/th.js",
	"./tl-ph.js": "./src/date-picker/locale/tl-ph.js",
	"./tlh.js": "./src/date-picker/locale/tlh.js",
	"./tr.js": "./src/date-picker/locale/tr.js",
	"./tzl.js": "./src/date-picker/locale/tzl.js",
	"./tzm-latn.js": "./src/date-picker/locale/tzm-latn.js",
	"./tzm.js": "./src/date-picker/locale/tzm.js",
	"./ug-cn.js": "./src/date-picker/locale/ug-cn.js",
	"./uk.js": "./src/date-picker/locale/uk.js",
	"./ur.js": "./src/date-picker/locale/ur.js",
	"./uz-latn.js": "./src/date-picker/locale/uz-latn.js",
	"./uz.js": "./src/date-picker/locale/uz.js",
	"./vi.js": "./src/date-picker/locale/vi.js",
	"./x-pseudo.js": "./src/date-picker/locale/x-pseudo.js",
	"./yo.js": "./src/date-picker/locale/yo.js",
	"./zh-cn.js": "./src/date-picker/locale/zh-cn.js",
	"./zh-hk.js": "./src/date-picker/locale/zh-hk.js",
	"./zh-tw.js": "./src/date-picker/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/date-picker/locale sync recursive ^\\.\\/.*\\.js$";